
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/luxury-hotels-e-gift-card",
      function () {
        return require("private-next-pages/luxury-hotels-e-gift-card/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/luxury-hotels-e-gift-card"])
      });
    }
  